import LazyLoad from "../LazyLoad";

export const Routes = [
    {
        name: '集团综合数据大屏',
        path: '/bigScreen/production',
        element: LazyLoad('/bigScreen/detail/productionScreen'),
    }
];
